<template>
    <div>
        <v-toolbar flat color="white">
            <v-toolbar-title style="color:#1C2546;margin-top:40px">Seguimiento de Comprobantes</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-toolbar flat color="white">
            <v-divider ></v-divider>
        </v-toolbar>
        <v-tabs fixed-tabs v-model="tabs">
            <v-tab :key="0">Individuales</v-tab>
            <v-tab :key="1">Grupos</v-tab>
            <v-tab-item :key="0">
                <v-data-table :headers="headers"  :items="solicitudes" :search="searchSolicitud"  class="elevation-1">
                    <template v-slot:item.actions="{ item }">
                        <v-icon :disabled="item.estatus!=='Rechazado'" small class="mr-2" @click="editItem(item)"> mdi-pencil</v-icon>
                        <v-icon small @click="get_detalles_solicitud(item)">mdi-eye</v-icon> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <v-icon small @click="getHistorialIndividual(item)">mdi-playlist-check</v-icon>
                        <v-icon :disabled="item.estatus!=='Rechazado'" small @click="open_dialog_delete(item)">mdi-delete</v-icon>
                    </template>
                    <template v-slot:top>
                        <v-row></v-row>
                        <v-dialog v-model="dialog_historial" max-width="1000px">
                                <v-card>
                                    <v-card-title><span class="headline">Historial de movimientos</span></v-card-title>
                                    <v-card-text>
                                        <v-data-table :headers="headers_historial" :items="historial" class="elevation-1"></v-data-table>
                                    </v-card-text>
                                </v-card>     
                        </v-dialog>
                        <v-dialog v-model="detalles_solicitud" max-width="1000px">
                                <v-card>
                                    <v-card-title><span class="headline">Detalles de solicitud</span></v-card-title>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="4" sm="4" md="4">
                                                <p><strong>Fecha de solicitud:</strong><br/> {{editedItem.fecha_solicitud}}</p>
                                            </v-col>
                                            <v-col cols="4" sm="4" md="4">
                                                <p><strong>Nombre solicitante:</strong><br/> {{editedItem.nombre}}</p>
                                            </v-col>
                                            <v-col cols="4" sm="4" md="4">
                                                <p><strong>Tipo gasto:</strong><br/> {{editedItem.nombre_cuenta}}</p>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="4" sm="4" md="4">
                                                <p><strong>Divisa:</strong><br/> {{editedItem.divisa}}</p>
                                            </v-col>
                                            <v-col cols="4" sm="4" md="4">
                                                <p><strong>Archivo Presentado:</strong><br/> {{editedItem.tipo_archivo_solicitud}}</p>
                                            </v-col>
                                            <v-col cols="4" sm="4" md="4">
                                                <p><strong>Locación de Gasto:</strong><br/> {{editedItem.locacion_solicitud}}</p>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="3" sm="3" md="3">
                                                <p><strong>Subtotal:</strong><br/> $ {{editedItem.subtotal}}</p>
                                            </v-col>
                                            <v-col cols="3" sm="3" md="3">
                                                <p><strong>IVA:</strong><br/> $ {{editedItem.iva}}</p>
                                            </v-col>
                                            <v-col cols="3" sm="3" md="3">
                                                <p><strong>Total:</strong><br/> $ {{editedItem.total}}</p>
                                            </v-col>
                                            <v-col cols="3" sm="3" md="3">
                                                <p><strong>Total (Cambio de divisa):</strong><br/> {{editedItem.importe_cambio}}</p>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="show_propina_details">
                                            <v-col cols="12" sm="4" md="4">
                                                <p><strong>Propina:</strong><br/> {{editedItem.propina}}</p>
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <p><strong>Descripción Propina:</strong><br/> {{editedItem.descripcion_propina}}</p>
                                            </v-col>
                                            <v-col cols="12" sm="4" md="4">
                                                <p><strong>Comensales Propina:</strong><br/> {{editedItem.comensales_propina}}</p>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="editedItem.comentarios!=null">
                                            <v-col cols="12" sm="12" md="12">
                                                <p><strong>Comentarios:</strong><br/> {{editedItem.comentarios}}</p>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <p><strong>Descripción:</strong><br/> {{editedItem.descripcion}}</p>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <strong>Comprobantes</strong> <br />
                                                <v-data-table :headers="fileHeaders" :items="archivos_solicitud" class="elevation-1"> 
                                                    <template v-slot:item.actionsFile="{ item }">
                                                        <v-icon small class="mr-1" @click="download_file(item)">mdi-download</v-icon>
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="detalles_solicitud = false">Cerrar</v-btn>
                                        </v-card-actions>
                                    </v-card-text>
                                </v-card>  
                        </v-dialog>
                        <v-dialog v-model="dialog_detalle_una"  max-width="60%">  
                                <v-card>
                                    <v-card-title><span class="headline">Editar Solicitud</span></v-card-title>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="editedItem.nombre" label="Deudor" value="editedItem.nombre" disabled></v-text-field>
                                            </v-col>  
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-textarea  v-model="editedItem.anotaciones" label="Anotaciones Supervisor" value="editedItem.anotaciones" :disabled="user.nivel_acceso !== 'supervisor'"></v-textarea>
                                            </v-col>  
                                            <v-col cols="12" sm="6" md="6">
                                                <v-textarea v-model="editedItem.anotaciones_financiero" label="Anotaciones Financiero" value="editedItem.anotaciones_financiero" :disabled="user.nivel_acceso !== 'financiero'"></v-textarea>
                                            </v-col> 
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y  max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-model="editedItem.fecha_solicitud" label="Fecha Comprobación" append-icon="mdi-calendar" v-on="on" :filled="editedItem.id_tipo_archivo_solicitud == 1" :disabled="editedItem.id_tipo_archivo_solicitud == 1" ></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="editedItem.fecha_solicitud" no-title @input="menu2 = false" :max='new Date().toISOString().slice(0,10)'></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-text-field v-model="editedItem.total" label="Total" value="editedItem.total" :filled="editedItem.id_tipo_archivo_solicitud == 1" :disabled="editedItem.id_tipo_archivo_solicitud == 1"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-select :items="divisas" item-value="id_divisa" item-text="divisa" v-model="editedItem.id_divisa" value="editedItem.id_divisa"  label="Divisa" :filled="editedItem.id_tipo_archivo_solicitud == 1" :disabled="editedItem.id_tipo_archivo_solicitud == 1"></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-select v-model='editedItem.id_cuenta' :items="cuentas" value='editedItem.id_cuenta' item-value="id_cuenta" item-text="nombre_cuenta" label="Tipo Gasto" @change="mostrar_descripciones_propina"></v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row >
                                            <v-col cols="12" sm="6" md="6" v-if="editedItem.id_forma_solicitud==='2'">
                                                <v-text-field v-model="editedItem.monto_cambio" label="Tipo Cambio" value="editedItem.monto_cambio" :filled="editedItem.id_tipo_archivo_solicitud == 1" :disabled="editedItem.id_tipo_archivo_solicitud == 1"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="6" v-if="requiere_anexos" >
                                                <v-text-field v-model="editedItem.propina" label="Propina" value="editedItem.propina"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6" v-if="descripciones_propina" >
                                                <v-textarea v-model="editedItem.descripcion_propina" label="Descripción de propina" value="editedItem.descripcion_propina" ></v-textarea>
                                            </v-col> 
                                            <v-col cols="12" sm="6" md="6" v-if="descripciones_propina" >
                                                <v-textarea v-model="editedItem.comensales_propina" label="Comensales de propina" value="editedItem.comensales_propina" ></v-textarea>
                                            </v-col>  
                                        </v-row>
                                        <div v-if="requiere_descripcion">
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                <v-textarea prepend-icon="mdi-text-subject" label="Comentarios" v-model="editedItem.comentarios"></v-textarea>
                                                </v-col>
                                            </v-row>    
                                        </div>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-textarea v-model="editedItem.descripcion" label="Descripción" value="editedItem.descripcion" :filled="editedItem.id_tipo_archivo_solicitud == 1" :disabled="editedItem.id_tipo_archivo_solicitud == 1"></v-textarea>
                                            </v-col>  
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <h6 style="margin-bottom: 20px">Comprobantes</h6>
                                                <v-data-table :headers="fileHeaders" :items="fileItems" class="elevation-1"> 
                                                    <template v-slot:item.actionsFile="{ item }">
                                                        <v-icon small class="mr-1" @click="download_file(item)">mdi-download</v-icon>
                                                        <v-icon small class="mr-1" @click="delete_file(item)" v-if='(editedItem.id_forma_solicitud ==="1" && item.id_tipo_archivo!=="1")'>mdi-delete</v-icon>
                                                        <v-icon small class="mr-1" @click="delete_file(item)" v-if='(editedItem.id_forma_solicitud ==="2")'>mdi-delete</v-icon>
                                                    </template>
                                                </v-data-table>
                                            </v-col>  
                                        </v-row>
                                        <v-row v-if="editedItem.id_forma_solicitud==='2'">
                                            <v-col cols="12" sm="12" md="12">
                                                <v-file-input v-model="editedItem.comprobantes" ref="fileInput" placeholder="Agregar comprobantes" label="Comprobantes" multiple prepend-icon="mdi-paperclip" >
                                                    <template v-slot:selection="{ text }">
                                                        <v-chip small label color="primary">{{ text }}</v-chip>
                                                    </template>
                                                </v-file-input>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="requiere_anexos">
                                            <v-col cols="12" sm="12" md="12">
                                                <v-file-input v-model="editedItem.anexos" ref="fileInput" placeholder="Agregar anexos" label="Anexos" multiple prepend-icon="mdi-paperclip" >
                                                    <template v-slot:selection="{ text }">
                                                        <v-chip small label color="primary">{{ text }}</v-chip>
                                                    </template>
                                                </v-file-input>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialog_detalle_una = false">Cancelar</v-btn>
                                        <v-btn color="blue darken-1" text @click="save()" :disabled="is_waiting"> <label v-if="!is_waiting">Confirmar</label> <v-progress-circular small indeterminate color="primary" v-if="is_waiting" :size="20"></v-progress-circular></v-btn>
                                    </v-card-actions>
                                </v-card>    
                        </v-dialog>
                        <v-dialog v-model="dialog_confirmar_borrar" max-width="50%">
                                <v-card>
                                    <v-card-title><span class="headline">Borrar Solicitud</span></v-card-title>
                                    <v-card-text> ¿Estas seguro de borrar esta solicitud? </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialog_confirmar_borrar = false">Cancelar</v-btn>
                                        <v-btn color="blue darken-1" text @click="delete_solicitud" :disabled="is_waiting"> <label v-if="!is_waiting">Confirmar</label> <v-progress-circular small indeterminate color="primary" v-if="is_waiting" :size="20"></v-progress-circular></v-btn>
                                    </v-card-actions>
                                </v-card> 
                        </v-dialog>
                        <v-alert type="success" :value='alert' close-text="Cerrar" dismissible style="margin-top:40px">Solicitud editada con exito.</v-alert>
                        <v-alert type="success" :value='alert_delete' close-text="Cerrar" dismissible style="margin-top:40px">Solicitud eliminada con exito.</v-alert>
                        <div style="margin-top:35px">
                            <v-btn class="ma-2" color="primary" @click="refresh">Actualizar</v-btn>
                        </div>
                        <v-row justify="center">
                            <v-col cols="10" sm="10" md="10">
                                <v-text-field v-model="searchSolicitud" append-icon="mdi-magnify" label="Buscar"> </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-tab-item>
            <v-tab-item :key="1">
                <v-data-table :headers="headers_grupos"  :items="grupos" :search="searchSolicitud"  class="elevation-1">
                    <template v-slot:top>
                        <v-row></v-row>
                        <div style="margin-top:35px">
                            <v-btn class="ma-2" color="primary" @click="refresh_grupos">Actualizar</v-btn>
                        </div>
                        <v-row justify="center">
                            <v-col cols="10" sm="10" md="10">
                                <v-text-field v-model="search_grupos" append-icon="mdi-magnify" label="Buscar"> </v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click="get_detalles_grupo(item)">mdi-eye</v-icon>
                    </template>
                </v-data-table>
            </v-tab-item>
        </v-tabs>
        <v-dialog v-model="dialog_solicitudes_grupo"  max-width="80%">
            <v-card>
            <v-card-title class="headline"> Solicitudes en Grupo </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="solicitudes_grupo" :search="search_solicitudes_grupos" item-key="id_solicitud" sort-by="fecha" class="elevation-1">
                <template v-slot:top>
                    <div class="text-right" style="margin-top:35px">
                    </div>
                    <v-card-title style="margin-top40px"> 
                    <v-text-field v-model="search_solicitudes_grupos" append-icon="mdi-magnify" label="Buscar" single-line hide-details ></v-text-field>
                    </v-card-title>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon :disabled="item.estatus!=='Rechazado'" small class="mr-2" @click="editItem(item)"> mdi-pencil</v-icon>
                    <v-icon small @click="get_detalles_solicitud(item)">mdi-eye</v-icon> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    <v-icon small @click="getHistorialIndividual(item)">mdi-playlist-check</v-icon>
                    <v-icon :disabled="item.estatus!=='Rechazado'" small @click="open_dialog_delete(item)">mdi-delete</v-icon>
                </template>
                </v-data-table>
            </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import router from '../router/index.js';
import { v4 as uuidv4 } from "uuid";

export default {
    data(){
        return {
            headers:[
                { text: "fecha", value: "fecha_modified", sortable: true, width: "5%" },
                { text: "Deudor", value: "nombre" , align: "left", sortable: true, width: "15%"},
                { text: "Número Factura", value: "numero_factura",width: "10%"},
                { text: "Concepto", value: "nombre_cuenta", width: "10%" },
                { text: "Tipo", value: "tipo_solicitud", width: "5%" },
                { text: "Total", value: "total_edited", width: "10%" },
                { text: "Divisa", value: "divisa", width: "5%" },
                { text: "Descripcion", value: "descripcion", sortable: true, width: "20%" },
                {text: "Estatus Jefe Directo", value: "estatus", sortable: true, width: "5%" },
                {text: "Estatus Financiero", value: "estatus_financiero", sortable: true , width: "5%"},
                {text: "Acciones", value: "actions", sortable: false, width: "10%" }
            ],
            headers_historial: [
                { text: "Fecha", value: "fecha", sortable: true},
                { text: "Usuario", value: "user", sortable: false },
                { text: "Estado", value: "estatus", sortable: false },
                { text: "Detalle", value: "descripcion", sortable: false }
            ],
            solicitudes: [],
            grupos: [],
            historial: [],
            solicitudes_grupo: [],
            dialog_historial: false,
            dialog_solicitudes_grupo: false,
            searchSolicitud: '',
            searchGrupo: '',
            search_solicitudes_grupos:'',
            dialog_grupos: false, 
            show_propina_details: false,
            dialog_confirmar_borrar: false,
            alert_delete : false,
            requiere_descripcion: false,
            search_grupos: '',
            grupo_selected_id:0,
            total_sol_grupo:0,
            archivos_solicitud: [],
            headers_grupos: [
                { text: "Fecha", value: "fecha_modified", sortable: true },
                { text: "Nombre grupo", value: "nombre" },
                { text: "Descripcion grupo", value: "descripcion" },
                { text: "Monto total", value: "monto_total" },
                { text: "Solicitudes totales", value: "solicitudes_totales" },
                { text: "Solicitudes en proceso", value: "num_pendientes" },
                { text: "Solicitudes aprobadas totalmente", value: "num_aprobadas" },
                { text: "Solicitudes rechazadas (total o parcial)", value: "num_rechazadas" },
                { text: "Acciones", value: "actions", sortable: false }
            ],
            headers_en_grupo: [
                { text: "Fecha de Comprobación", value: "fecha_comprobacion", sortable: true },
                { text: "Deudor", align: "left", sortable: true, value: "deudor" },
                { text: "Concepto", value: "concepto" },
                { text: "Importe", value: "importe_modified" },
                { text: "Cuenta", value: "cuenta" },
                { text: "Tipo", value: "tipo", sortable: true },
                { text: "Descripcion", value: "descripcion", sortable: true },
                { text: "Estatus Jefe Directo", value: "estatus", sortable: true },
                { text: "Estatus Financiero", value: "estatus_financiero", sortable: true },
                { text: "Acciones", value: "actionsSGrupo", sortable: false }
            ],
            solicitudes_en_grupo: [],
            dialog_detalle: false,
            editedIndex: -1,
            alert: false,
            editedItem: {
                IdSolicitud: "",
                Documentos:"",
                Deudor: "",
                idconcepto: "",
                Estado: "",
                Tipo: "",
                Cuenta: "",
                idcuenta:"",
                importe: "",
                Descripcion: "",
                fecha_comprobacion: "",
            },
            fileHeaders: [
                { text: "Archivo", value: "nombre_archivo"},
                { text: "Tipo de Archivo", value: "tipo_archivo"},
                { text: "Acciones", value: "actionsFile", sortable: false }
            ],
            fileItems: [],
            selected_grupo: [],
            files: null,
            empleados: [],
            divisas: [],
            menu2: false,
            descripciones_propina: false,
            requiere_anexos: false,
            tipo: ["Comprobación", "Anticipo"],
            cuentas: [       
                {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"1"},
                {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"2"},
                {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"3"},
                {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"4"},
                {cuenta :"ALQUILER TRANSPORTES", idcuenta:"5"},
                {cuenta :"ALQUILER TRANSPORTES ND", idcuenta:"6"},
                {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"7"},
                {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"8"},
                {cuenta :"GASOLINA", idcuenta:"9"},
                {cuenta :"GASOLINA ND", idcuenta:"10"},
                {cuenta :"REEMBOLSO Y GASTOS VEHICULOS", idcuenta:"11"},
                {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"12"},
                {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"13"},
                {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"14"},
                {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"15"},
                {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"16"},
                {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"17"},
                {cuenta :"GASTOS COMUNES", idcuenta:"18"},
                {cuenta :"GASTOS COMUNES ND", idcuenta:"19"},
                {cuenta :"GASTOS COMUNES", idcuenta:"20"},
                {cuenta :"GASTOS COMUNES ND", idcuenta:"21"},
                {cuenta :"GASTOS DE LIBRERIA", idcuenta:"22"},
                {cuenta :"GASTOS DE LIMPIEZA", idcuenta:"23"},
                {cuenta :"MESSENGER SERVICES", idcuenta:"24"},
                {cuenta :"CUSTOMER GIFTS", idcuenta:"25"},
                {cuenta :"MEALS & ENTERTAINMENT", idcuenta:"26"},
                {cuenta :"MANTENIMIENTO VEHICULO", idcuenta:"27"},
                {cuenta :"MANTENIM DE MAT INFORMATICO", idcuenta:"28"},
            ],
            gastos: [
                { gasto: "Hotel", id_gasto: "1" },
                { gasto: "Alimentos", id_gasto: "2" },
                { gasto: "Renta de vehículo", id_gasto: "3" },
                { gasto: "Peaje", id_gasto: "4" },
                { gasto: "Gasolina", id_gasto: "5" },
                { gasto: "Avión", id_gasto: "6" },
                { gasto: "Autobús", id_gasto: "7" },
                { gasto: "Taxi", id_gasto: "8" },
                { gasto: "Estacionamiento", id_gasto: "9" },
                { gasto: "Despensa", id_gasto: "10" },
                { gasto: "Agua beber", id_gasto: "11" },
                { gasto: "Papelería", id_gasto: "12" },
                { gasto: "Limpieza", id_gasto: "13" },
                { gasto: "Mensajería", id_gasto: "14" },
                { gasto: "Regalos a clientes", id_gasto: "15" },
                { gasto: "Consumos de alimentos locales", id_gasto: "16" },
                { gasto: "Mtto auto", id_gasto: "17" },
                { gasto: "Gastos de celulares", id_gasto: "18" },
            ],
            dialog_detalle_una: false,
            searchSolicitudesGrupo: '',
            editing_group: null,
            detalles_solicitud: false,
            devisas: [],
            solicitud_raw:  {
                id_solicitud: "",
                id_divisa: "",
                id_cuenta: "",
                id_deudor: "",
                subtotal: "",
                iva: "",
                total: "",
                descripcion: "",
                monto_cambio: "",
                descripcion_propina: "",
                comensales_propina: "",
                propina: "",
                id_estatus: "",
                id_estatus_financiero: "",
                anotaciones: "",
                anotaciones_financiero: ""
            },
            is_waiting: false
        }
    },
    mounted() {
        // Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;
        axios.interceptors.response.use(function (response){
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        });
        // End config for axios
        this.getSolicitudes();
        this.get_conceptos();
        this.get_cuentas();
        this.get_divisas();
        this.get_grupos();
    },
    computed: {
        user() {
          return this.$store.state.user;
        },

    },
    methods: {
        get_divisas(){
          axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/divisas").then(res => { this.divisas = res.data; });
        },
        refresh(){
            this.getSolicitudes();
        },
        get_grupos() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/grupos/aprobaciones/todos").then(res => { this.grupos = res.data; });
        },
        get_conceptos() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/conceptos").then(res => { this.conceptos = res.data; });
        },
        get_cuentas() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/catalogos/cuentas").then(res => { this.cuentas = res.data; });
        },
        getSolicitudes() {
            this.solicitudes = [];
            axios.get("https://"+process.env.VUE_APP_URL+":3000/solicitud/"+'1').then(res => {
                res.data.forEach(element => {
                    this.solicitudes.push(element);
                });
            });
            axios.get("https://"+process.env.VUE_APP_URL+":3000/solicitud/"+'2').then(res => {
                res.data.forEach(element => {
                    this.solicitudes.push(element);
                });
            });
            axios.get("https://"+process.env.VUE_APP_URL+":3000/solicitud/"+'3').then(res => {
                res.data.forEach(element => {
                    this.solicitudes.push(element);
                });
            });
        },
        refresh_grupos() {
            this.get_grupos();
        },
        get_detalles_grupo(item){
            this.selected_grupo = item;
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/grupo/"+item.id_grupo).then(res => {
                this.solicitudes_grupo = res.data;
                this.total_sol_grupo = this.solicitudes_grupo.length
                this.grupo_selected_id=item.id_grupo
                this.dialog_solicitudes_grupo = true;
            });  
        },
        refresh_detalles_grupos(){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/grupo/"+this.selected_grupo.id_grupo).then(res => {
                this.solicitudes_grupo = res.data;
            }); 
        },
        getGrupos() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/grupos/"+'1').then(res => {
                res.data.forEach(element => {
                    this.grupos.push(element);
                }); 
            });
            axios.get("https://"+process.env.VUE_APP_URL+":3000/grupos/"+'2').then(res => {
                res.data.forEach(element => {
                    this.grupos.push(element);
                }); 
            });
            axios.get("https://"+process.env.VUE_APP_URL+":3000/grupos/"+'3').then(res => {
                res.data.forEach(element => {
                    this.grupos.push(element);
                }); 
            });
        },
        getHistorialIndividual(item){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/historial/"+item.id_solicitud).then(res => {
                this.historial = res.data.body;
                this.dialog_historial = true;
            });
        },
        getHistorialEnGrupo(item){
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/historial/"+item.id_solicitud).then(res => {
                this.historial = res.data.body;
                this.dialog_historial = true;
            });
        },
        getHistorialGrupo(item){
            this.editing_group = item;
            axios.get("https://"+process.env.VUE_APP_URL+":3000/solicitudGrupo/"+item.id).then(res => {
                this.solicitudes_en_grupo = res.data;
                this.dialog_grupos = true;
            });
        },
        open_dialog_delete(item){
            this.selected_solicitud = item;
            this.dialog_confirmar_borrar = true;
        },
        delete_solicitud(){
            this.is_waiting = true;
            axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/eliminar/",this.selected_solicitud).then(() => {
                this.getSolicitudes();
                this.get_grupos();
                if (this.dialog_solicitudes_grupo === true) {
                    this.refresh_detalles_grupos();
                    this.get_grupos();
                }
                this.is_waiting = false;
                this.dialog_confirmar_borrar = false;
                this.alert_delete = true;
            });
        },
        getEmpleados: async function(){
            axios.get('https://'+process.env.VUE_APP_URL+':3000/select/empleados/comprobacion/' + this.$store.state.user.id_puesto)
            .then((response) => {
                this.empleados = response.data;
                if(response.data.length <= 1){
                this.readonlySelect = true;
                }
            })
        },
        editItem(item) {
            item.id_cuenta = parseInt(item.id_cuenta);
            item.id_divisa = parseInt(item.id_divisa);
            item.fecha_solicitud = item.fecha_solicitud.substr(0, 10);
            this.editedItem = Object.assign({}, item);
            this.editedItem.descripcion_propina = (this.editedItem.descripcion_propina==='undefined' ? null: this.editedItem.descripcion_propina);
            this.editedItem.comensales_propina = (this.editedItem.comensales_propina==='undefined' ? null: this.editedItem.comensales_propina);
            var obj_selected = this.cuentas.filter(item => { return item.id_cuenta === this.editedItem.id_cuenta});
            if(obj_selected[0]['es_anexo_comida']===true){
                this.descripciones_propina=true;
            }else{
                this.descripciones_propina=false;
            }
            if(obj_selected[0]['requiere_anexo']===true){
                this.requiere_anexos=true;
            }else{
                this.requiere_anexos=false;
            }
            if(obj_selected[0]['requiere_descripcion']===true){
                this.requiere_descripcion=true;
            }else{
                this.requiere_descripcion=false;
            }
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos/"+this.editedItem.id_solicitud).then(res => { 
                this.fileItems = res.data; 
                this.dialog_detalle_una = true;
            });
        },
        close () {
            this.dialog_detalle = false
            this.dialog_detalle_una = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },
        saveUna () {
            let IdSolicitud = this.editedItem.IdSolicitud;
            let idconcepto = this.editedItem.idconcepto;
            let Tipo = this.editedItem.Tipo;
            let Cuenta = this.editedItem.Cuenta;
            let idcuenta= this.editedItem.idcuenta;
            let importe = this.editedItem.importe;
            let Descripcion = this.editedItem.Descripcion;
            let FechaComprobacion = this.editedItem.FechaComprobacion;
            var data_f=new FormData()
            for(let x in this.files){
                data_f.append('files',this.files[x]);
            }
            data_f.append('id',IdSolicitud);
            data_f.append('Idconcepto',idconcepto);
            data_f.append('fechaC',FechaComprobacion);
            data_f.append('importe',importe);
            data_f.append('idcuenta',idcuenta);
            data_f.append('cuenta',Cuenta);
            data_f.append('tipo',Tipo);
            data_f.append('descripcion',Descripcion);
            data_f.append('idH',uuidv4());

            if (this.editedItem.estatus == 'Rechazado') {
                data_f.append('estatus','1');
            }

            axios.put("https://"+process.env.VUE_APP_URL+":3000/solicitud", data_f).then(()=>{
                //this.gastos = res.data;
                this.alert=true;
                this.files = null;
                this.close();
                this.getSolicitudes();
            });
        },
        create_array_data(solicitud){
            this.solicitud_raw['id_solicitud'] = solicitud.id_solicitud;
            this.solicitud_raw['id_deudor'] = solicitud.id_deudor;
            this.solicitud_raw['id_divisa'] = solicitud.id_divisa;
            this.solicitud_raw['id_cuenta'] = solicitud.id_cuenta;
            this.solicitud_raw['subtotal'] = solicitud.subtotal;
            this.solicitud_raw['iva'] = solicitud.iva;
            this.solicitud_raw['total'] = solicitud.total;
            this.solicitud_raw['descripcion'] = solicitud.descripcion;
            this.solicitud_raw['monto_cambio'] = solicitud.monto_cambio;
            this.solicitud_raw['descripcion_propina'] = solicitud.descripcion_propina;
            this.solicitud_raw['comensales_propina'] = solicitud.comensales_propina;
            this.solicitud_raw['comentarios'] = solicitud.comentarios;
            this.solicitud_raw['propina'] = solicitud.propina;
            this.solicitud_raw['id_estatus'] = 1;
            this.solicitud_raw['id_estatus_financiero'] = null;
            this.solicitud_raw['anotaciones'] = '';
            this.solicitud_raw['anotaciones_financiero'] = '';
        },
        save() {
            this.alert = false;
            if (this.requiere_anexos) { 
                this.editedItem.propina = parseFloat(parseFloat(this.editedItem.total)*0.10).toFixed(2);
            }
            this.create_array_data(this.editedItem);
            let IdGrupo=0
            if(this.tabs==1){
                IdGrupo=this.grupo_selected_id
            }
            axios.put("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes", {"solicitud": JSON.stringify(this.solicitud_raw), "grupo" :IdGrupo , "total_solicitudes": this.total_sol_grupo}).then(() => {
                var form_file = new FormData();
                form_file.append('id_solicitud', this.editedItem.id_solicitud);
                if (this.editedItem.comprobantes !== undefined) {
                    this.editedItem.comprobantes.forEach(file => form_file.append('comprobantes', file));
                }
                if (this.editedItem.anexos !== undefined) {
                    this.editedItem.anexos.forEach(file => form_file.append('anexos', file));
                }
                if (this.editedItem.comprobantes !== undefined || this.editedItem.anexos !== undefined) {
                    axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos", form_file).then(() => {
                        this.alert = true;
                        this.getSolicitudes();
                        if (this.dialog_solicitudes_grupo===true){
                            this.refresh_detalles_grupos();
                            this.get_grupos();
                        }
                        this.dialog_detalle_una = false;
                        
                    });
                }else{
                    this.alert = true;
                    this.getSolicitudes();
                    if (this.dialog_solicitudes_grupo===true){
                        this.refresh_detalles_grupos();
                        this.get_grupos();
                    }
                    this.dialog_detalle_una = false;
                }
            });
        },
        download_file(item){
            window.open("https://" +
          process.env.VUE_APP_URL +
          ":3000/open/" +
          item.id_solicitud +
          "/" +
          item.nombre_archivo)
            /*
            axios({
                url: "https://"+process.env.VUE_APP_URL+":3000/download/"+item.id_solicitud+'/'+item.nombre_archivo,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', item.nombre_archivo);
                document.body.appendChild(link);
                link.click();
            });
            */
        },
        delete_file(item){
            axios.post('https://'+process.env.VUE_APP_URL+':3000/delete/file',item)
            .then((response) => {            
                if(response.data.message === 'Archivo eliminado'){
                    axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos/"+this.editedItem.id_solicitud).then(res => { 
                        this.fileItems = res.data; 
                    });
                }
            });
        },
        getCuenta() {
            var idg = this.editedItem.idconcepto;
            axios.get("https://"+process.env.VUE_APP_URL+":3000/cuentasgastos/" + idg).then(res => {
            this.cuentas = res.data;
            });
        },
        mostrar_descripciones_propina() {
            var obj_selected = this.cuentas.filter(obj => { return obj.id_cuenta === this.editedItem.id_cuenta});
            if(obj_selected[0]['es_anexo_comida']===true){
                this.descripciones_propina=true;
            }else{
                this.descripciones_propina=false;
            }
            if(obj_selected[0]['requiere_anexo']===true){
                this.requiere_anexos=true;
            }else{
                this.requiere_anexos=false;
            }
            if(obj_selected[0]['requiere_descripcion']===true){
                this.requiere_descripcion=true;
            }else{
                this.requiere_descripcion=false;
            }
        },
        get_detalles_solicitud(data) {
            this.editedItem = Object.assign({}, data);
            this.editedItem.descripcion_propina = (this.editedItem.descripcion_propina==='undefined' ? null: this.editedItem.descripcion_propina);
            this.editedItem.comensales_propina = (this.editedItem.comensales_propina==='undefined' ? null: this.editedItem.comensales_propina);
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/solicitudes/archivos/"+this.editedItem.id_solicitud).then(res => { 
                this.archivos_solicitud = res.data; 
                this.detalles_solicitud = true;
            });
            var obj_selected = this.cuentas.filter(item => { return item.id_cuenta === this.editedItem.id_cuenta});
            if(obj_selected[0]['requiere_descripcion']===true){
                this.requiere_descripcion=true;
            }else{
                this.requiere_descripcion=false;
            }
            if (this.editedItem.descripcion_propina !== '') {
                this.show_propina_details = true;
            } else {
                this.show_propina_details = false;
            }
        }
    }  
}
</script>

<style>

</style>